import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestsDetailsComponent } from 'src/app/tests/tests-details/tests-details.component';
import { TestsLandingComponent } from 'src/app/tests/tests-landing/tests-landing.component';
import { AddClientComponent } from './collection/add-client/add-client.component';
import { AddCollectionComponent } from './collection/add-collection/add-collection.component';
import { CollectionLandingComponent } from './collection/collection-landing/collection-landing.component';
import { CollectionhomeComponent } from './collection/collectionhome/collectionhome.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChooseQuestionTypeComponent } from './items/choose-question-type/choose-question-type.component';
import { CreateNewItemComponent } from './items/create-new-item/create-new-item.component';
import { AbcComponent } from './items/item-details/abc.component';
import { ItemDetailsComponent } from './items/item-details/item-details.component';
import { ItemLandingComponent } from './items/item-landing/item-landing.component';
import { AuthGuard } from './services/auth.guard';
import { LoginComponent } from './user/login/login.component';
import { UserCreateComponent } from './users/user-create/user-create.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { UserLandingComponent } from './users/user-landing/user-landing.component';
// import { ExamineeloginComponent } from './examineelogin/examineelogin.component';
import { AddTestsScheduleComponent } from './tests/add-tests-schedule/add-tests-schedule.component';
// import { ScheduleDetailsComponent } from './tests/schedule-details/schedule-details.component';
import { ItemsMatchOrderMatchListComponent } from '@items/question/items-match-order-match-list/items-match-order-match-list.component';
import { ItemsMultipleChoiceMultipleResponseComponent } from '@items/question/items-multiple-choice-multiple-response/items-multiple-choice-multiple-response.component';
import { ItemsMultipleChoiceSingleResponseComponent } from '@items/question/items-multiple-choice-single-response/items-multiple-choice-single-response.component';
import { ItemsMultipleChoiceTrueOrFalseComponent } from '@items/question/items-multiple-choice-true-or-false/items-multiple-choice-true-or-false.component';
import { ItemsSurveyLikeDislikeComponent } from '@items/question/items-survey-like-dislike/items-survey-like-dislike.component';
import { ItemsSurveyMultiResponseComponent } from '@items/question/items-survey-multi-response/items-survey-multi-response.component';
import { ItemsSurveyNumberRatingComponent } from '@items/question/items-survey-number-rating/items-survey-number-rating.component';
import { ItemsSurveyShortAnswerComponent } from '@items/question/items-survey-short-answer/items-survey-short-answer.component';
import { ItemsSurveySingleChoiceComponent } from '@items/question/items-survey-single-choice/items-survey-single-choice.component';
import { ItemsSurveyStarRatingComponent } from '@items/question/items-survey-star-rating/items-survey-star-rating.component';
import { CollectionDetailsComponent } from './collection/collection-details/collection-details.component';
import { ExamineeLoginComponent } from './delivery/examinee-login/examinee-login.component';
import { ChangePasswordComponent } from './header/change-password/change-password.component';
import { AssignPrivilegesComponent } from './header/roles/assign-privileges/assign-privileges.component';
import { RolesComponent } from './header/roles/roles.component';
import AddMultipleItemComponent from './items/item-landing/add-multiple-item/add-multiple-item.component';
import { NoAuthGuard } from './services/no-authguard.service';
import { TestRedirectionComponent } from './test-redirection/test-redirection.component';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { SubscriptionComponent } from './header/subscription/subscription.component';
import { TwoFactorAuthenticationComponent } from './user/two-factor-authentication/two-factor-authentication.component';
import { TwoFactorAuthenticationDComponent } from './delivery/two-factor-authentication-d/two-factor-authentication-d.component';
import { ExamineeResetPasswordComponent } from './delivery/reset-password/reset-password.component';
import { ChangePasswordSComponent } from './user/change-password/change-password.component';
import { ChangePasswordDComponent } from './delivery/change-password/change-passwordD.component';
import { PageNotFoundComponent } from './delivery/page-not-found/page-not-found.component';
import { HomeComponent } from './home/home/home.component';
import { PatientLandingComponent } from './Assessment/patient-landing/patient-landing.component';
import { PatientAssessmentDetailsComponent } from './Assessment/patient-assessment-details/patient-assessment-details.component';
// import { PrivacyPolicyComponent } from './user/privacy-policy/privacy-policy.component';
let dcid = 0;
const a = () => {
  if (sessionStorage.getItem('defaultcollectionuuid')) {
    dcid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid') || '{}');
  }
};
a();

const routes: Routes = [
  { path: 'sg/:id', component: TestRedirectionComponent },
  { path: 'login', component: LoginComponent, canActivate: [NoAuthGuard] },
  { path: 'twoFactorAuth', component: TwoFactorAuthenticationComponent },
  { path: 'collections', component: CollectionhomeComponent, canActivate: [AuthGuard] },
  { path: 'collections/add', component: AddCollectionComponent, canActivate: [AuthGuard] },
  {
    path: 'collections/:id', component: CollectionLandingComponent, canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: '', component: CollectionDetailsComponent },
      { path: 'tags', loadChildren: () => import('./tags/tags.module').then(m => m.TagsModule) },
      { path: 'create-new-item', component: CreateNewItemComponent },
      { path: 'items', component: ItemLandingComponent },
      { path: 'items/uploaditems', component: AddMultipleItemComponent },
      {
        path: 'items/:id', component: AbcComponent,
        children: [
          { path: '', component: ItemDetailsComponent },
          { path: 'selectquestiontype', component: ChooseQuestionTypeComponent },
          { path: 'addstandardmcquestion', component: ItemsMultipleChoiceSingleResponseComponent },
          { path: 'addstandardquestioncheckbox', component: ItemsMultipleChoiceMultipleResponseComponent },
          { path: 'addstandardquestiontruefalse', component: ItemsMultipleChoiceTrueOrFalseComponent },
          { path: 'addsurveyschoice', component: ItemsSurveySingleChoiceComponent },
          { path: 'Serveymultipal', component: ItemsSurveyMultiResponseComponent },
          { path: 'SurveyShortAnswer', component: ItemsSurveyShortAnswerComponent },
          { path: 'SurveyLikeDislike', component: ItemsSurveyLikeDislikeComponent },
          { path: 'SurveyStarRating', component: ItemsSurveyStarRatingComponent },
          { path: 'SurveyNumberRating', component: ItemsSurveyNumberRatingComponent },
          { path: 'MatchOrder', component: ItemsMatchOrderMatchListComponent },
        ]
      },
      { path: 'home', component: HomeComponent },
      { path: 'assessments', component: PatientLandingComponent },
      { path: 'assessmentdetails/:id', component: PatientAssessmentDetailsComponent},
      { path: 'tests', loadChildren: () => import('./delivery/delivery.module').then(m => m.DeliveryModule) },
      { path: 'add-client', component: AddClientComponent },
      { path: 'test', component: TestsLandingComponent },
      { path: 'tests/:id', component: TestsDetailsComponent },
      { path: 'schedules', loadChildren: () => import('./schedules/schedules.module').then(m => m.SchedulesModule) },
      { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule), },
      { path: 'analytics', loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule) },
      { path: 'scheduledetails/:id', component: AddTestsScheduleComponent },
    ]
  },
  { path: 'users', component: UserLandingComponent, canActivate: [AuthGuard] },
  { path: 'users/add', component: UserCreateComponent, canActivate: [AuthGuard] },
  { path: 'users/:id', component: UserEditComponent, canActivate: [AuthGuard] },
  { path: 'examinees', loadChildren: () => import('./examiness/examiness.module').then(m => m.ExaminessModule), canActivate: [AuthGuard] },
  { path: 'examinee-group', loadChildren: () => import('./examinees-group/examinee-group.module').then(m => m.ExamineeGroupModule), canActivate: [AuthGuard] },
  { path: 'delivery', loadChildren: () => import('./delivery/delivery.module').then(m => m.DeliveryModule), canActivate: [AuthGuard] },
  { path: 'td/login/:id', component: ExamineeLoginComponent },
  { path: 'td/twoFactorAuthD/:id', component: TwoFactorAuthenticationDComponent },
  { path: 'reset-examinee-password', component: ExamineeResetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: '', redirectTo: 'collections/' + dcid, pathMatch: 'full' },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'changePassword', component: ChangePasswordSComponent },
  { path: 'change-Passwordd', component: ChangePasswordDComponent },
  { path: 'roles', component: RolesComponent },
  { path: 'subscription', component: SubscriptionComponent },
  { path: 'Assign-privileges', component: AssignPrivilegesComponent },
  { path: 'Assign-privileges/:id', component: AssignPrivilegesComponent },
  { path: 'Page-Not-Found', component: PageNotFoundComponent },
  // { path: 'privacy-policy', component: PrivacyPolicyComponent, canActivate: [NoAuthGuard] }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

